import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_HallSweepConsequence } from "../shared/data.service";
import { HS_ConsequenceRequest } from "../shared/HS_ConsequenceRequest";

@Component({
	selector: "app-consequence-modify",
	templateUrl: "./consequence-modify.component.html",
	styleUrls: ["./consequence-modify.component.css"],
})
export class ConsequenceModifyComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private consequenceService: DataService_HallSweepConsequence,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.EditMode = this.dialogConfig.data.EditMode;

		if (this.EditMode == true) {
			this.ConsequenceID = this.dialogConfig.data.ConsequenceID;
			this.ConsequenceTrigger = this.dialogConfig.data.ConsequenceTrigger;
			this.ConsequenceDesc = this.dialogConfig.data.ConsequenceDesc;
		}
	}

	/////////////////////////////////////////
	// Data
	/////////////////////////////////////////

	EditMode: any = false;

	ConsequenceID: any = -1;
	ConsequenceTrigger: any = 1;
	ConsequenceDesc: any = "";

	errorMessage: any = "";

	/////////////////////////////////////////

	/////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////

	onProcess() {
		this.errorMessage = "";

		if (this.ConsequenceTrigger <= 0) {
			this.errorMessage = "Consequence Trigger must be > 0";
			return;
		}

		this.CheckConsequenceInUse();
	}

	CheckConsequenceInUse() {
		var result = this.consequenceService.ConsequenceExistsSelect(this.ConsequenceID, this.ConsequenceTrigger);
		result.subscribe(
			(response) => {
				var Data = response[0];

				if (Data.Exists == true) {
					//Fail Dialog

					var MSG = "Could not ";

					if (this.EditMode == false) {
						MSG += "add";
					} else {
						MSG += "update";
					}

					MSG +=
						" the consequence because another consequence already occurs at " +
						this.ConsequenceTrigger +
						" occurence" +
						(this.ConsequenceTrigger != 1 ? "s" : "") +
						': "' +
						Data.Desc +
						'"';

					this.confirmationService.confirm({
						key: "modifyconfirm",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: MSG,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				} else {
					if (this.EditMode == false) {
						this.FinishAdd();
					} else {
						this.FinishEdit();
					}
				}
			},
			(error) => {}
		);
	}

	FinishAdd() {
		let parms: HS_ConsequenceRequest = {
			ConsequenceID: this.ConsequenceID,
			ConsequenceDesc: this.ConsequenceDesc,
			ConsequenceTrigger: this.ConsequenceTrigger,
		};

		var result = this.consequenceService.ConsequenceInsert(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "modify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Consequence was added successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "modify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not add the Consequence",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	FinishEdit() {
		let parms: HS_ConsequenceRequest = {
			ConsequenceID: this.ConsequenceID,
			ConsequenceDesc: this.ConsequenceDesc,
			ConsequenceTrigger: this.ConsequenceTrigger,
		};

		var result = this.consequenceService.ConsequenceUpdate(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "modify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Consequence was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "modify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the Consequence",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	/////////////////////////////////////////
}
